import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { IPreassignationsParam } from "../preassignations/types"
import { IMySubstitution } from "./types"
import api from "services/api"
import { ISubstitutionApplication } from "../substitution-requests/types"

export function useMySubstitutions(
  params?: IPreassignationsParam,
  config?: UseQueryOptions<IMySubstitution[]>
) {
  return useQuery<IMySubstitution[]>(
    ["suite", "time", "assignations", "substitutions", params],
    {
      keepPreviousData: true,
      ...config,
    }
  )
}

export function useSubstitutionApplications(
  substitutionId?: string,
  config?: UseQueryOptions<ISubstitutionApplication[]>
) {
  return useQuery<ISubstitutionApplication[]>(
    [
      "suite",
      "time",
      "assignations",
      "substitutions",
      substitutionId,
      "propositions",
    ],
    {
      enabled: !!substitutionId,
      ...config,
    }
  )
}

export function useAcceptSubstitute(
  substitutionId: string,
  config?: UseMutationOptions<unknown, unknown, string>
) {
  const queryClient = useQueryClient()
  return useMutation(
    (propositionId) =>
      api.post(
        `suite/time/assignations/substitutions/${substitutionId}/propositions/${propositionId}/confirm`
      ),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.invalidateQueries([
          "suite",
          "time",
          "assignations",
          "substitutions",
        ])
      },
    }
  )
}

export function useDeleteMySubstitution(
  config?: UseMutationOptions<unknown, unknown, string>
) {
  const queryClient = useQueryClient()
  return useMutation<unknown, unknown, string>(
    (mySubstitutionId) =>
      api.delete(`suite/time/assignations/substitutions/${mySubstitutionId}`),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.setQueryData<IMySubstitution[]>(
          ["suite", "time", "assignations", "substitutions", null],
          (queryData) => queryData?.filter((el) => el.id !== vars)
        )
        queryClient.invalidateQueries([
          "suite",
          "time",
          "assignations",
          "substitutions",
        ])
      },
    }
  )
}
